import { Link, LinkField, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { ExtendedItem } from 'src/types/ExtendedItem';

import styles from './QuickLinks.module.css';

type QuickLinksProps = ComponentProps & {
	fields: {
		Links: ExtendedItem &
			[
				{
					fields: {
						Link: LinkField;
					};
				}
			];
	};
};

export default withDatasourceCheck()<QuickLinksProps>(QuickLinks1);

function QuickLinks1(props: QuickLinksProps): JSX.Element {
	return (
		<section className="blueDark padYS">
			<div className="maxWidth padX">
				{props.fields?.Links && props.fields?.Links.length > 0 && (
					<ul className={`${styles.list} cen listReset`}>
						{props.fields?.Links.map((item, index) => (
							<li key={`quicklinks-${index}`}>
								<Link className={`${styles.link} link linkOffset linkHoverWeighted`} field={item.fields?.Link} />
							</li>
						))}
					</ul>
				)}
			</div>
		</section>
	);
}
